import * as archiveActions from './actions';
import archiveEpics from './epics';
import reducer from './reducers';
import * as archiveSelectors from './selectors';
import * as archiveTypes from './types';

export { archiveActions, archiveEpics, archiveSelectors, archiveTypes };

export default reducer;
